<div class="sidenav-user text-center">
    <button class="setting-primary" type="button" (click)="showDialogInfoPatient()">
        <i class="far fa-eye"></i>
    </button>
    <button *ngIf="patientObj.data.isFused" class="patient-fusion" type="button" matTooltip="Paciente fusionado" matTooltipClass="tt-below" matTooltipPosition="right">
        <i class="far fa-merge"></i>
    </button>

    <div class="user-avatar-wrp">
        <ng-container *ngIf="hasImage; else letterLogo">
            <div class="{{classType}}">
                <app-image [image]="patientObj?.data?.imageB64Id" classImage="img-fluid rounded-circle user-avatar-pic"></app-image>
            </div>
        </ng-container>
        <ng-template #letterLogo>
            <app-image [fullName]="patientObj?.data?.fullName" classContainer="{{classType}}" classImage="h3 user-avatar-txt"></app-image>
        </ng-template>
        <strong class="{{priorityType}}">{{priority}}</strong>
    </div>

    <h6 class="mt-3 mb-0 text-primary-emphasis sidenav-user-name">{{patientObj?.data?.fullName}}</h6>
    <p class="mb-0 sidenav-user-title">Expediente: {{patientObj?.data?.patientRecordId}}</p>

    <div class="row user-info mt-3">
        <div class="col">
            {{ getSexStr(sexObj$ | async) }}
            <p class="text-start">Sexo<br>
            <strong>{{patientObj.data.biologicalSexName}}</strong>
            </p>
        </div>
        <div class="col">
            <p class="text-center">Edad<br>
            <strong>{{ getAge(patientObj?.data?.patientBirthDate) }} años</strong>
            <!-- <strong>{{patientObj?.data?.patientBirthDate | age}}</strong> -->
            </p>
        </div>
        <div class="col">
            <p class="text-end">Sangre<br>
            <strong>o+</strong>
            </p>
        </div>
    </div>

    <div class="row justify-content-center">
        <div class="col-8 user-alerts">
            <div class="row">
                <div class="col">
                    <mat-icon [matTooltip]="allergyTooltip" matTooltipClass="tt-below" matTooltipPosition="below" [color]="getAllergyIconColor(allergyStatus)">
                        <i class="far fa-hand-dots"></i>
                    </mat-icon>
                </div>
                <div class="col">
                    <mat-icon matTooltip="Influenza A" matTooltipClass="tt-below" matTooltipPosition="below" color="primary">
                        <i class="far fa-virus-covid"></i>
                    </mat-icon>
                </div>
                <div class="col">
                    <mat-icon matTooltip="No existe un consentimiento informado" matTooltipClass="tt-below" matTooltipPosition="below" color="none">
                        <i class="fa-regular fa-file-medical"></i>
                    </mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>
